import { contact } from "../assets";
import { layout } from "../style";
import  Form from "./Form";

const CardDeal = () => (
  <section className={layout.section} id="contactUs">
    <div className={layout.sectionImg}>
      <img src={contact} alt="Contact Software India - Get in touch for software development services" className="md:w-[90%] w-full" />
    </div>
    <div className={layout.sectionInfo}>
    <Form id="contact"/>
    </div>
  </section>
);

export default CardDeal;